import React from "react";
import {Button, CircularProgress,TextField} from "@material-ui/core";
import {ACTIVITY_TAG, API_KEY} from "../../../utils/constants";
import axios from "axios";
import {createApiServerRoute} from "../../../models/network/api_client";
import UrlArgsBundle from "../../../core/url_args_bundle";
import {withRouter} from "react-router-dom";
import moment from "moment";

class UpdateResultFragment extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            khanapara_fr : 'XX',
            khanapara_sr : 'XX',
            shilong_fr : 'XX',
            shilong_sr : 'XX',
            all_histories: [],
            loadingStates: {
                fr_kp: false,
                sr_kp: false,
                fr_sl: false,
                sr_sl: false
            }
        }
    }

    sendNotification = async (key, type) => {
        this.setState(prevState => ({
            loadingStates: { ...prevState.loadingStates, [key]: true }
        }));

        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY);
        params.append("mode", "topic");
        params.append("type", type);

        const config = {
            headers: { "Content-Type": "application/x-www-form-urlencoded" }
        };

        try {
            const res = await axios.post(createApiServerRoute('send_result_notification.php'), params, config);
            if (res.data.state === 'OK') {
                alert(`Notification sent for ${type.toUpperCase()}`);
            } else {
                alert(`Failed to send alert for ${type}`);
            }
        } catch (error) {
            alert(`Error sending alert for ${type}`);
        } finally {
            this.setState(prevState => ({
                loadingStates: { ...prevState.loadingStates, [key]: false }
            }));
        }
    }

    renderButton = (label, key, type) => {
        const isLoading = this.state.loadingStates[key];
        return (
            <Button
                className="h-12 rounded-xl font-medium"
                variant="contained"
                color="primary"
                onClick={() => this.sendNotification(key, type)}
                disabled={isLoading}
            >
                {isLoading ? (
                    <>
                        <CircularProgress size={24} color="inherit" style={{ marginRight: 8 }} />
                        Sending...
                    </>
                ) : (
                    label
                )}
            </Button>
        );
    }

    getPlayHistory = ()=>{
        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY)
        const config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        };

        axios.post(createApiServerRoute('fetch_all_users_bid_histories.php'), params, config)
            .then(res => {
                if (res.data.state === 'OK') {
                    const mergeResult = res.data.data.bids.teer_bid_histories
                    const sortedResult=mergeResult.slice(0).sort((a,b)=>
                        a.played_at.localeCompare(b.played_at));
                    this.setState({
                        all_histories: sortedResult
                        // all_histories: sortedResult.filter(item=>moment(item['played_at']).format('DD-MM-YYYY') === moment(new Date()).format('DD-MM-YYYY'))
                    })
                } else {
                    console.log(res)
                }
            });
    }

    componentDidMount() {
        this.getPlayHistory()
        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY)
        const config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        };

        // let gameType = this.urlArgsBundle.getStringExtra('gameType');
        // let subCategory = this.urlArgsBundle.getStringExtra('subCategory')

        axios.post(createApiServerRoute('fetch_teer_results.php'), params, config)
            .then(res => {
                if (res.data.state === 'OK') {
                    console.log("res.data.data.teer_results",res.data.data.teer_results);
                    if(res.data.data.teer_results != null){
                    this.setState({
                        ...this.state,
                        khanapara_fr : res.data.data.teer_results.khanapara_fr,
                        khanapara_sr : res.data.data.teer_results.khanapara_sr,
                        shilong_fr : res.data.data.teer_results.shilong_fr,
                        shilong_sr : res.data.data.teer_results.shilong_sr,
                        
                    })
                    }
                }
            });
    }

    updateGameRate = (type) => {
        console.log("all_histories",this.state.all_histories);
       // return;
        const params = new URLSearchParams();
        params.append("__api_key__", API_KEY)
        params.append("khanapara_fr", this.state.khanapara_fr)
        params.append("khanapara_sr", this.state.khanapara_sr)
        params.append("shilong_fr", this.state.shilong_fr)
        params.append("shilong_sr", this.state.shilong_sr)

        params.append("type", type)

        const config = {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            }
        };

        axios.post(createApiServerRoute('add_teer_result.php'), params, config)
            .then(res => {
                if (res.data.state === 'OK') {
                    window.location.reload();
                    // let tag = this.urlArgsBundle.getStringExtra('gameType') + "_GAMES"
                    // this.props.history.push(this.changeFragment(tag))
                }
            });
    }

    render() {
        return (
            <div className="py-10 bg-gradient-to-br from-gray-100 to-blue-50 min-h-screen flex justify-center items-start">
            <div className="flex gap-12 px-4 flex-wrap justify-center">
                <h1 className="w-full text-center text-indigo-700 text-3xl font-semibold mb-6">🎯 Update Results</h1>
        
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 w-full max-w-screen-xl">
                    {/* KHANAPARA FR */}
                    <div className="bg-white p-6 rounded-2xl shadow-xl border border-indigo-100 flex flex-col gap-4">
                        <TextField
                            fullWidth
                            label="KHANAPARA TEER FR"
                            value={this.state.khanapara_fr}
                            variant="outlined"
                            onChange={(e) => {
                                this.setState({ ...this.state, khanapara_fr: e.target.value });
                            }}
                        />
                        <Button
                            className="h-12 rounded-xl font-semibold tracking-wide"
                            variant="contained"
                            color="primary"
                            onClick={() => this.updateGameRate("khanapara_fr_result")}>
                            Update
                        </Button>
                    </div>
        
                    {/* KHANAPARA SR */}
                    <div className="bg-white p-6 rounded-2xl shadow-xl border border-indigo-100 flex flex-col gap-4">
                        <TextField
                            fullWidth
                            label="KHANAPARA TEER SR"
                            value={this.state.khanapara_sr}
                            variant="outlined"
                            onChange={(e) => {
                                this.setState({ ...this.state, khanapara_sr: e.target.value });
                            }}
                        />
                        <Button
                            className="h-12 rounded-xl font-semibold tracking-wide"
                            variant="contained"
                            color="primary"
                            onClick={() => this.updateGameRate("khanapara_sr_result")}
                            >
                            Update
                        </Button>
                    </div>
        
                    {/* SHILLONG FR */}
                    <div className="bg-white p-6 rounded-2xl shadow-xl border border-indigo-100 flex flex-col gap-4">
                        <TextField
                            fullWidth
                            label="SHILLONG TEER FR"
                            value={this.state.shilong_fr}
                            variant="outlined"
                            onChange={(e) => {
                                this.setState({ ...this.state, shilong_fr: e.target.value });
                            }}
                        />
                        <Button
                            className="h-12 rounded-xl font-semibold tracking-wide"
                            variant="contained"
                            color="primary"
                            onClick={() => this.updateGameRate("shilong_fr_result")}
                            >
                            Update
                        </Button>
                    </div>
        
                    {/* SHILLONG SR */}
                    <div className="bg-white p-6 rounded-2xl shadow-xl border border-indigo-100 flex flex-col gap-4">
                        <TextField
                            fullWidth
                            label="SHILLONG TEER SR"
                            value={this.state.shilong_sr}
                            variant="outlined"
                            onChange={(e) => {
                                this.setState({ ...this.state, shilong_sr: e.target.value });
                            }}
                        />
                        <Button
                            className="h-12 rounded-xl font-semibold tracking-wide"
                            variant="contained"
                            color="primary"
                            onClick={() => this.updateGameRate("shilong_sr_result")}
                            >
                            Update
                        </Button>
                    </div>
                </div>
           
                 
                    {/* Left Card: Input Fields 
                    <div className="form-card w-96 bg-white py-8 px-8 rounded-2xl shadow-2xl flex flex-col gap-6 border border-indigo-100">
                        <h1 className="text-center text-indigo-700 text-2xl font-semibold">🎯 Update Results</h1>
    
                        <TextField fullWidth label="KHANAPARA TEER FR" value={this.state.khanapara_fr} variant="outlined" onChange={(e) => {
                            this.setState({ ...this.state, khanapara_fr: e.target.value })
                        }} />
    
                        <TextField fullWidth label="KHANAPARA TEER SR" value={this.state.khanapara_sr} variant="outlined" onChange={(e) => {
                            this.setState({ ...this.state, khanapara_sr: e.target.value })
                        }} />
    
                        <TextField fullWidth label="SHILLONG TEER FR" value={this.state.shilong_fr} variant="outlined" onChange={(e) => {
                            this.setState({ ...this.state, shilong_fr: e.target.value })
                        }} />
    
                        <TextField fullWidth label="SHILLONG TEER SR" value={this.state.shilong_sr} variant="outlined" onChange={(e) => {
                            this.setState({ ...this.state, shilong_sr: e.target.value })
                        }} />
    
                        <Button className="h-12 rounded-xl font-semibold tracking-wide" variant="contained" color="primary" onClick={this.updateGameRate}>
                            Update Results
                        </Button>
                    </div>
    */}

                    {/* Right Card: Alert Buttons */}
                   {/* Right Card 
                   <div className="form-card w-80 bg-white py-8 px-6 rounded-2xl shadow-2xl flex flex-col gap-8 border-1 border-gray-300">
                        <h1 className="text-center text-indigo-700 text-2xl font-semibold">📢 Send Notifications</h1>
                        {this.renderButton(`KHANAPARA FR Alert`, "fr_kp", "result1")}
                        {this.renderButton(`KHANAPARA SR Alert`, "sr_kp", "result2")}
                        {this.renderButton(`SHILLONG FR Alert`, "fr_sl", "result3")}
                        {this.renderButton(`SHILLONG SR Alert`, "sr_sl", "result4")}
                    </div>
                    */}

                </div>
            </div>
        );
    }
    
    

}

export default withRouter(UpdateResultFragment)
